import { captureReferralCode } from "lib/referral/referralStorage";
import type { ReactNode } from "react";
import { useEffect } from "react";

interface ReferralCaptureProviderProps {
  children: ReactNode;
}

export default function ReferralCaptureProvider({ children }: ReferralCaptureProviderProps) {
  useEffect(() => {
    captureReferralCode();
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
